/* eslint-env jquery */
const $ = jQuery;

let headerHeight;
let headerMarginBottom;
const header = $('header');
$(document).ready(init);

function init() {
  headerHeight = header.outerHeight();
  headerMarginBottom = header.css('margin-top');
  $('html')
    .css('scroll-padding-top', `calc(${headerHeight}px + ${headerMarginBottom} + 40px)`)
    .css('scroll-margin-top', `calc(${headerHeight}px + ${headerMarginBottom} + 40px)`);
  const windowHeight = window.innerHeight;
  $('[data-bs-toggle="tooltip"]').tooltip();
  $('.modal').appendTo('body');
  if (window.matchMedia('(max-width: 991.98px)').matches) {
    $('#mega-menu-wrap-primary .mega-menu-toggle + #mega-menu-primary').css(
      'max-height',
      `calc(${windowHeight}px - ${headerHeight}px)`
    );
  }

  changeButtonSize();
  select();
  anchorScroll();
}

$(window).on('resize', resize);

function resize() {
  changeButtonSize();
}

function changeButtonSize() {
  $('[data-desktop="btn-sm"]').each(function () {
    if (window.matchMedia('(max-width: 991.98px)').matches) {
      $(this).removeClass('btn-sm');
    } else {
      $(this).addClass('btn-sm');
    }
  });
}

function select() {
  if ($('body').hasClass('parent-page-privacy-policy') || $('body').hasClass('terms-of-use')) {
    $('#otnotice-language-dropdown').change(() => {
      $('.otnotice-menu-mobile').remove();
      $('section.content .container').hide();
    });
  }
}

function anchorScroll() {
  const anchorSelector = 'a[href^="#"]';
  const anchorList = document.querySelectorAll(anchorSelector);
  for (const link of anchorList) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      headerHeight = header.outerHeight();
      $('html').css('scroll-padding-top', `calc(${headerHeight}px + 40px)`);

      let destination;

      if (this.hash) {
        destination = document.querySelector(this.hash);
      }

      if (destination) {
        destination.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  }
}

export { header };
